export default __webpack_public_path__ + "static/media/img_login.72ad0963.png";